"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Service Management Public REST API
 * Public REST API for Jira Service Management
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-a295e7484152fa2365a7ce8735dc664cc7adfec0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgebaseApi = void 0;
const tslib_1 = require("tslib");
const runtime = require("../../runtime");
const index_1 = require("../models/index");
/**
 *
 */
class KnowledgebaseApi extends runtime.BaseAPI {
    /**
     * Returns articles which match the given query string across all service desks.  **[Permissions](#permissions) required**: Permission to access the [customer portal](https://confluence.atlassian.com/servicedeskcloud/configuring-the-customer-portal-732528918.html).
     * Get articles
     */
    getArticlesRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['query'] == null) {
                throw new runtime.RequiredError('query', 'Required parameter "query" was null or undefined when calling getArticles().');
            }
            if (requestParameters['highlight'] == null) {
                throw new runtime.RequiredError('highlight', 'Required parameter "highlight" was null or undefined when calling getArticles().');
            }
            const queryParameters = {};
            if (requestParameters['query'] != null) {
                queryParameters['query'] = requestParameters['query'];
            }
            if (requestParameters['highlight'] != null) {
                queryParameters['highlight'] = requestParameters['highlight'];
            }
            if (requestParameters['start'] != null) {
                queryParameters['start'] = requestParameters['start'];
            }
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/knowledgebase/article`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PagedDTOArticleDTOFromJSON)(jsonValue));
        });
    }
    /**
     * Returns articles which match the given query string across all service desks.  **[Permissions](#permissions) required**: Permission to access the [customer portal](https://confluence.atlassian.com/servicedeskcloud/configuring-the-customer-portal-732528918.html).
     * Get articles
     */
    getArticles(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getArticlesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.KnowledgebaseApi = KnowledgebaseApi;
//# sourceMappingURL=KnowledgebaseApi.js.map